import { Link, Navigate, useParams } from "react-router-dom";
import { fortyDayPlan } from "./FortyDay.jsx";
import { techniquesById } from "../data/techniques.js";
import { Icon } from "../components/Icons.jsx";
import Seo from "../components/Seo.jsx";

export default function FortyDayDay() {
  const { n } = useParams();
  const dayNum = Number(n);
  const day = fortyDayPlan.find((d) => d.d === dayNum);
  if (!day) return <Navigate to="/40-day-challenge" replace />;
  const tech = techniquesById[day.techniqueId];
  const milestone = [7, 14, 21, 28, 40].includes(dayNum);
  const prev = dayNum > 1 ? dayNum - 1 : null;
  const next = dayNum < 40 ? dayNum + 1 : null;

  return (
    <>
      <Seo
        title={`Day ${day.d} · ${day.title} · 40-Day Challenge`}
        description={`Day ${day.d} of 40. ${tech.modern}`}
        path={`/40-day-challenge/day-${day.d}`}
      />
      <section className="section-night" style={{ paddingTop: 60, paddingBottom: 40 }}>
        <div className="container">
          <Link to="/40-day-challenge" style={{ color: "var(--gold)", textDecoration: "none", fontFamily: "var(--mono)", fontSize: 12, letterSpacing: "0.18em", textTransform: "uppercase" }}>
            ← 40-Day Challenge
          </Link>
          <div style={{ display: "flex", gap: 20, alignItems: "baseline", marginTop: 28 }}>
            <div style={{ color: milestone ? "var(--gold)" : "var(--ivory)", fontFamily: "var(--serif)", fontSize: 90, lineHeight: 1, fontWeight: 500 }}>
              {String(day.d).padStart(2, "0")}
            </div>
            <div>
              <div style={{ color: "var(--gold)", fontFamily: "var(--mono)", fontSize: 11, letterSpacing: "0.22em", textTransform: "uppercase" }}>
                Day {day.d} of 40 · Source verse {tech.sourceVerse} · {day.family}{milestone && " · Milestone"}
              </div>
              <h1 style={{ color: "var(--ivory)", fontFamily: "var(--serif)", fontWeight: 400, fontSize: "clamp(32px, 4.4vw, 54px)", lineHeight: 1.05, marginTop: 8 }}>
                {day.title}
              </h1>
            </div>
          </div>
        </div>
      </section>

      <section className="section-ivory">
        <div className="container">
          <div className="featured-wrap">
            <div className="featured-left">
              <div className="tech-block"><div className="lbl">Ancient Essence</div><p style={{ fontStyle: "italic" }}>"{tech.essence}"</p></div>
              <div className="tech-block modern"><div className="lbl">Modern Translation</div><p>{tech.modern}</p></div>
            </div>
            <div className="featured-right">
              <h4>Practice · 10 minutes</h4>
              <ol className="steps">{tech.steps.map((s, i) => <li key={i}>{s}</li>)}</ol>
              <div className="warn"><b>Common mistake →</b> {tech.mistake}</div>
              <div style={{ marginTop: 28, padding: "18px 20px", background: "#0F172A", borderRadius: 12, color: "var(--ivory)" }}>
                <div style={{ fontFamily: "var(--mono)", fontSize: 10.5, letterSpacing: "0.2em", color: "var(--gold)", marginBottom: 8 }}>REFLECTION QUESTION</div>
                <div style={{ fontSize: 15, lineHeight: 1.6, color: "rgba(248,241,231,0.92)", fontStyle: "italic" }}>"{tech.prompt}"</div>
              </div>
              <div style={{ marginTop: 28, display: "flex", gap: 10, flexWrap: "wrap" }}>
                <Link className="btn btn-primary" to={`/technique/${tech.id}`}>Open Full Technique {Icon.arrowSm()}</Link>
              </div>
            </div>
          </div>
          <div style={{ marginTop: 60, display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 20 }}>
            {prev ? (
              <Link to={`/40-day-challenge/day/${prev}`} className="btn btn-secondary" style={{ background: "transparent", color: "var(--copper)", border: "1px solid var(--border)" }}>
                ← Day {prev}
              </Link>
            ) : <span />}
            {next ? (
              <Link to={`/40-day-challenge/day/${next}`} className="btn btn-primary">Day {next} {Icon.arrowSm()}</Link>
            ) : (
              <Link to="/journal" className="btn btn-primary">Review Your Journey {Icon.arrowSm()}</Link>
            )}
          </div>
        </div>
      </section>
    </>
  );
}
